
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import item from './resumen-atributos-item.vue';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Imagen } from '@/__env/lib/Articulos/Imagenes';
    import { Wait } from '@/__env/ext';
    import { Atributo } from '@/__env/lib/Articulos/Atributos';
    import moment, { Moment } from 'moment';
    import _ from 'lodash';
import { AtributosGenerales } from '@/__env/lib/Articulos/AtributosGenerales/AtributosGenerales.nav';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            item
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Articulo() { return this.Controlador.Articulo; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        @Prop()
        public Abierto: boolean;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto && !this.Iniciado )
            {
                this.Iniciar();
            }
        }

        public Iniciado: boolean = false;
        public Cargando: boolean = false;
        public Guardando: boolean = false;
        public Error: boolean = false;
        public UltimaModificacion: Moment = null;
        public Atributos: Atributo[] = [];
        public Generales: AtributosGenerales = new AtributosGenerales();

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            //this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( x => this.Iniciar() ) );
            //this.Iniciar();
        }

        async Iniciar()
        {
            this.Cargando = true;
            this.Atributos.clear();
            this.Generales = new AtributosGenerales();

            await this.Articulo.CargarAtributos();
            if ( this.Articulo.Atributos.hasRows() )
            {

                this.Atributos.push( ...this.Articulo.Atributos );
                this.Iniciado = true;
            }

            this.Generales = this.Articulo.AtributosGenerales;
            let ab = await this.Articulo.CargarAtributoTitulo();
            this.Atributos.push( ...ab );

            let e = new Atributo();
            e.Articulo = this.Articulo.Id;
            this.Atributos.push( e );

            this.Cargando = false;
            this.Refrescar();
        }

        public Agregar()
        {
            if ( this.Atributos.hasRows() )
            {
                let ult = this.Atributos[this.Atributos.length - 1];
                if ( !ult.Existe && ult.Valor )
                {
                    let e = new Atributo();
                    e.Articulo = this.Articulo.Id;
                    this.Atributos.push( e );
                }
            }
        }

        public async Cancelar()
        {
            this.Atributos.clear();
            this.Cargando = true;
            await this.Iniciar();
            this.Cargando = false;
        }

        public async Guardar()
        {
            this.Guardando = true;
            let rr = true;
            for ( let at of this.Atributos )
            {
                await Wait( 100 );
                if ( at.Descripcion && at.Valor )
                {
                    let ar = false;
                    if ( at.Existe )
                        ar = await at.save();
                    else
                        ar = await this.Articulo.AgregarAtributo( at.Descripcion, at.Valor, at.NoCorresponde ) != null;

                    if ( !ar )
                    {
                        this.$EventBus.Notificaciones.Error( 'Error al guardar' );
                        rr = false;
                        break;
                    }
                }
            }

            let ar = await this.Generales.save();
            if ( ar )
            {
                this.UltimaModificacion = moment();
            } else
            {
                this.$EventBus.Notificaciones.Error( 'Error al guardar' );
                rr = false;
            }

            if ( rr )
                await this.Iniciar();

            this.Guardando = false;
        }

        public async Eliminar( atributo: Atributo )
        {
            this.Guardando = true;
            if ( atributo.Existe )
            {
                let ar = await atributo.del();
                if ( ar )
                {
                    console.log( this.Atributos.findIndex( x => x.Id == atributo.Id ) );
                    this.Articulo.Atributos.splice( this.Articulo.Atributos.findIndex( x => x.Id == atributo.Id ), 1 );
                    this.Atributos.splice( this.Atributos.findIndex( x => x.Id == atributo.Id ), 1 );
                } else
                {
                    this.$EventBus.Notificaciones.Error( 'Error al eliminar el atributo' );
                }
            } else
            {
                this.Atributos.splice( this.Atributos.findIndex( x => x.nId == atributo.nId ), 1 );
            }

            let aa = [...this.Atributos];
            this.Atributos = aa;
            this.Refrescar();

            this.Guardando = false;
        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
